<dialog-draggable-header>Program Maintenance</dialog-draggable-header>

<mat-dialog-content>
   <data-table [data]="programs" [columns]="columns" [filterColumnDisplay]="false" [totalRecords]="total"
      [loading]="loading" [paging]="true" [pageSize]="pageOptions.size" [lazy]="true" (lazyLoad)="onLazyLoad($event)"
      (edit)="updateProgram($event)" (select)="updateSelectedProgram($event)">
      <ng-container actionStart>
         <button mat-button (click)="onAddProgramClick()" (keypress.enter)="onAddProgramClick()">Add Program</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <span class="vertical-center">
            <button class="pad-right-sm" mat-button (click)="onToolFrontLoaderClick()"
               (keypress.enter)="onToolFrontLoaderClick()">
               Tool Front Loader
            </button>
         </span>
         <mat-form-field class="spacerLeft">
            <input #searchBar id="search-program-id" type="text" matInput (keydown.enter)="searchByProgram(searchBar)"
               [(ngModel)]="searchBarInput" placeholder="Search Program Name" />
            <span *ngIf="searchBarInput" style="margin-left:-20px;">
               <a (click)="clearSearch()">
                  <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
               </a>
            </span>
            <button mat-icon-button matSuffix (click)="searchByProgram(searchBar)"
               (keydown.enter)="searchByProgram(searchBar)">
               <mat-icon matSuffix>search</mat-icon>
            </button>
         </mat-form-field>
      </ng-container>
      <ng-container actionEnd>
         <button mat-button (click)="close()" (keydown.enter)="close()">Close</button>
      </ng-container>
   </data-table>
</mat-dialog-content>
